module.exports = __webpack_public_path__ + "static/parcel-cd9d50050fffe2145ea99bcf62fe3a64.png";